import styled, { StyledComponent } from 'styled-components';
import { hexToRGB, rgbaToRGB } from 'utils/colorUtils';
import { BREAKPOINT } from '../constants';

interface WebinarRootContainerProps {
  isMultiTrackSession?: boolean;
  trackColor?: string;
}

const getBackgroundColor = (trackColor: string) => {
  if (trackColor) {
    const RGB = hexToRGB(trackColor);
    return `rgb(${rgbaToRGB([...RGB, 0.2])})`;
  }
  return 'rgb(255, 255, 255)';
};

export default styled.div<WebinarRootContainerProps>`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 24px;
  box-sizing: border-box;
  border-radius: 4px;
  color: #484848;
  position: relative;
  border: 2px solid ${(props) => (props.trackColor || '#DBDEE2')};
  background: ${({ trackColor }) => getBackgroundColor(trackColor)};

  @media (min-width: ${BREAKPOINT}px) {
    ${({ isMultiTrackSession }) => isMultiTrackSession && 'height: calc(100% - 12px);'}
    margin: 12px 0;
    margin-top: 0;
  }

  &::before {
    pointer-events: none;
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }

  @media (max-width: ${BREAKPOINT}px) {
    margin: 16px 0;
    margin-top: 0;
  }
` as StyledComponent<'div', any, WebinarRootContainerProps>;
